setTimeout(() => {
  const observer = new MutationObserver((MutationList) => {
    for(let item of MutationList){
      if(item.target.className.includes('atc-banner--container visible') && item.attributeName === 'class'){
        fetch('/cart.js').then(res => res.json()).then(data => {
            if(data.items.length){
              let a = new Map();
              for(let item of data.items){
                a.set(item.product_title, item.key);
              }
              const title_elm = document.querySelector(".atc--product-details--title");
               const inner_banner = document.querySelector(".atc-banner--inner"); 
              if(title_elm && inner_banner){
                  if(a.get(title_elm.innerHTML) && !inner_banner.hasAttribute('data-cart-item-key')){
                    inner_banner.setAttribute('data-cart-item-key', a.get(title_elm.innerHTML));
                  }
              }
            }
        })
       setTimeout(() => {
          BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false);
         BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
       }, 500)

      }
    }
  })
  observer.observe(document.body, {attributes: true, childList: true, subtree: true})
}, 300)